import {
  Task,
  taskZod,
  TasksResp,
  tasksRespZod,
} from 'packages/lib/api/annotations/contract/task';
import {
  TaskGroup,
  taskGroupZod,
} from 'packages/lib/api/annotations/contract/task-group';
import { annotationsApi } from 'packages/lib/api/annotations/rest';
import useSWR, { SWRResponse } from 'swr';

type APIOptions = { enabled?: boolean; showErrorToast?: boolean };

export function useTaskByTokenSWR(
  taskToken: string | null | undefined,
  { enabled = true, showErrorToast = false }: APIOptions = {}
): SWRResponse<Task> {
  return useSWR(
    enabled && taskToken ? `/tasks/${taskToken}` : null,
    (apiPath: string) =>
      annotationsApi.get(apiPath, taskZod.parse, showErrorToast)
  );
}

export function useTaskGroupByTokenSWR(
  taskGroupToken: string | null | undefined,
  { enabled = true, showErrorToast = false }: APIOptions = {}
): SWRResponse<TaskGroup> {
  return useSWR(
    enabled && taskGroupToken ? `/task-groups/${taskGroupToken}` : null,
    (apiPath: string) =>
      annotationsApi.get(apiPath, taskGroupZod.parse, showErrorToast)
  );
}

type UseTaskParams = APIOptions & {
  query?: URLSearchParams;
};

export function useTasksSWR({
  enabled = true,
  showErrorToast = false,
  query,
}: UseTaskParams = {}): SWRResponse<TasksResp> {
  const queryString = query?.toString();
  const endpoint = queryString ? `/tasks?${queryString}` : '/tasks';

  return useSWR(enabled ? endpoint : null, (endpoint: string) =>
    annotationsApi.get(endpoint, tasksRespZod.parse, showErrorToast)
  );
}
